<template>
  <PageVenueFilter :value="venueId" @input="$store.dispatch('pos/general/selectVenueId', $event)">
    <PriceShiftWindows v-if="venueId" :venueId="venueId" />
  </PageVenueFilter>
</template>

<script>
import { mapGetters } from "vuex";
import PageVenueFilter from "@/components/Custom/PageVenueFilter.vue";
import PriceShiftWindows from "./PriceShiftWindows";

export default {
  components: {
    PageVenueFilter,
    PriceShiftWindows
  },
  computed: {
    ...mapGetters({
      venueId: "pos/general/selectedVenueId"
    })
  }
};
</script>